import reduxStore from 'redux/store'
import { setResource } from 'redux/actions'
import Endpoints from 'constants/Endpoints';
import RestRequest from 'libs/RestRequest';
import { setInnerMenuOpen } from 'redux/actions'


const get = async () => {
	let url = Endpoints.USER_LOGGED_MENU_LIST;
	try {
		const res = await RestRequest({
			method: 'get',
			url,
		})
		reduxStore.dispatch(
			setResource('userLoggedMenuList', res)
		)

		let objKey = {}
		res.forEach(x => {
			let temp = x.name.split(".")
			objKey[temp[1]] = false
		});
		reduxStore.dispatch(
			setInnerMenuOpen(objKey)
		)

	} catch (error) {
	}
}

export default {
	get,
}
